import frCoreMessages from "~/core/config/i18n/translations/fr"

import scriptLoader from "@/utils/loadScript";

export default scriptLoader.mergeObjects(frCoreMessages, {
  "Find a nearby relay point": "Trouver un point-relais proche",
  "seo": {
    "defaultTitle": "Votre partenaire e-commerce dans les îles",
    "titlePrefix": "Shop E Dom {rootCategoryLabel} - ",
    "titleSuffix": ""
  },
  "topBar": {
    "allIncludePrices": {
      "titleHTML": "✈️ Nos tarifs incluent le transport et les taxes.",
      "button": "Plus d'infos 📦"
    },
    "maintenance": {
      "titleHTML": "<b>Une maintenance est en cours car notre catalogue évolue, les produits seront disponibles rapidement.</b>"
    }
  },
  "relay": {
    "select": "Choisir point-relais"
  },
  "cart": {
    "empty": {
      "message": "Consultez notre catalogue et faites‑vous plaisir...",
      "title": "Votre panier est vide !"
    }
  },
  "priceDetails": {
    "taxInclItemsTotal": "Total articles"
  },
  "header": {
    "region": {
      "title": "Changer de région"
    }
  },
  "footer": {
    "menu": {
      "columns": {
        "a-propos": "A propos",
        "services": "Services",
        "legal": "Informations légales"
      }
    }
  },
  "cms": {
    "sed-business": "Shop E Dom business"
  },
  "featured": {
    "description": "",
    "title": "Nos ##Meilleurs## offres"
  },
  "pages": {
    "products": {
      "characteristics": {
        "title": "Caractéristiques du produit"
      }
    },
    "checkout": {
      "shipping": {
        "title": "Votre adresse",
        "logicalClassSplitting": "Bénéficier d'une livraison plus rapide par avion pour les articles éligibles",
        "noAddress": {
          "actions": {
            "addAddress": "Ajouter une adresse"
          },
          "error": "Veuillez renseigner une adresse de livraison {0}"
        },
        "noSelectedAddress": {
          "error": "Veuillez sélectionner une adresse de livraison"
        },
        "hasAddress": {
          "actions": {
            "createNew": "Ajouter une adresse"
          }
        },
        "relay": {
          "title": "Votre point relais",
          "description": "",
        }
      }
    }
  },
  "Your e-mail": "Votre adresse e-mail",
  "myOrders": {
    "order": {
      "parcelsTracking": {
        "events": {
          "SHIPMENT": "EXPÉDITION",
          "INFO": "INFORMATION",
          "DELIVERY": "LIVRAISON",
          "RETURN": "RETOUR"
        }
      }
    }
  },
  "cookie": {
    "notice": {
      "description": "Shop E Dom utilise des cookies fonctionnels et analytiques pour permettre le bon fonctionnement de ce site et vous offrir la meilleure expérience possible. Si vous utilisez ce site, des cookies fonctionnels et analytiques vont être installés sur votre navigateur.\nAvec votre consentement, nous utilisons également des cookies marketing pour analyser nos performances marketing et personnaliser les offres présentées dans nos publicités. En utilisant ces cookies, Shop E Dom et des tiers peuvent suivre votre comportement sur internet pour vous proposer du contenu et des publicités en lien avec vos centres d'intérêt.\nEn cliquant sur Accepter, vous consentez à l'utilisation de tous les cookies marketing. Si vous cliquez sur Refuser, nous n'utiliserons aucun cookie marketing. Vous pouvez modifier les paramètres des cookies ou retirer votre consentement à tout moment."
    }
  },
  "components": {
    "orkReassurance": {
      "fastDelivery": "Livraison rapide"
    },
    "orkRootCategory": {
      "title": "Choisissez votre région",
      "hint": "Sélectionnez une région"
    },
    "orkNewsletter": {
      "title": "Restez connecté",
      "subtitle": "Inscrivez-vous à notre newsletter"
    }
  },
  "phoneValidation": {
    "error": {
      "0": "Numéro incorrect",
      "1": "Code pays invalide",
      "2": "Numéro trop court",
      "3": "Numéro trop long",
      "4": "Format international incorrect",
      "5": "Longueur invalide",
      "-99": "Numéro incorrect"
    }
  },
  "shipmentOption": {
    "price": {
      "free": "Inclus"
    }
  },
  "sed": {
    "product_flag_deliverable_by_plane": "Livraison rapide par avion disponible"
  },
  "Please add a shipping address located {0}": "Veuillez ajouter une adresse de livraison située {0}"
})